import React from 'react';
import { ServerResponse } from 'http';
import { fetchNavHTML } from 'libs/server/nav';
import { fetchUser } from 'libs/server/users';

import { GetServerSideProps } from 'next';
import IncomingMessageWithCookies from 'types/IncomingMessageWithCookies';

import AdvisorLp from 'components/AdvisorLp';
import { AdvisorLpProps } from 'components/AdvisorLp/AdvisorLp';

const WebsiteV3LPContainer: React.FC<AdvisorLpProps> = (props): JSX.Element => {
  return <AdvisorLp {...props} />;
};

export default WebsiteV3LPContainer;

export const getServerSideProps: GetServerSideProps<AdvisorLpProps> = async ({
  req,
}: {
  req: IncomingMessageWithCookies;
  res: ServerResponse;
}) => {
  const [navHTML, userCtx] = await Promise.all([fetchNavHTML(req), fetchUser(req)]);

  return {
    props: {
      navHTML,
      userCtx,
    },
  };
};
